import React from "react";
import { DPRestrictedPage } from "Components/DP";
import { Grid, Typography } from "@material-ui/core";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { PageNotFound } from "..";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { DisbursementsDatePicker } from "./DisbursementsDatePicker/DisbursementsDatePicker";
import { ProviderDisbursementsTable } from "./ProviderDisbursementsTable/ProviderDisbursementsTable";
import { RequestorFilter } from "./RequestorFilter/RequestorFilter";

const OffCycleDisbursementsReport = () => {
  const { permissions, offCyclePaymentOptions } = usePartnerConfig();
  const hideReport =
    !offCyclePaymentOptions.enableOffCycleDisbursements
    || !permissions.canViewCycleReports;

  if (hideReport) {
    return (
      <PageNotFound />
    );
  }

  return (
    <DPRestrictedPage title="Off-Cycle Disbursements Report" permissionKey="canViewReports">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h2" >
            Off-Cycle Disbursements Report
          </Typography>
        </Grid>
        <HelpText>
          <b>What is the Off-Cycle Disbursements Report?</b> A list of all off-cycle payments sent within the past year.
        </HelpText>
        <Grid item container xs={12}>
          <DisbursementsDatePicker />
          <RequestorFilter />
        </Grid>
        <Grid item xs={12}>
          <ProviderDisbursementsTable />
        </Grid>
      </Grid>
    </DPRestrictedPage>
  );
};

export default OffCycleDisbursementsReport;
